import { Personverninnstilling, hasPersonverninnstilling } from './hn-user';
export var Samtykke;
(function (Samtykke) {
    /** Bruker har ikke samtykket til Helsenorge */
    Samtykke[Samtykke["Ingen"] = 0] = "Ingen";
    /** Bruker har basis-samtykke */
    Samtykke[Samtykke["Basis"] = 1] = "Basis";
    /** Bruker har Basis+-samtykke */
    Samtykke[Samtykke["BasisPluss"] = 2] = "BasisPluss";
    /** Bruker har fullt samtykke */
    Samtykke[Samtykke["Full"] = 3] = "Full";
})(Samtykke || (Samtykke = {}));
/**
 * Sjekker hvilket nivå av bruk av helsenorge innbygger har samtykket til.
 * @returns Full, BasisPluss, Basis eller Ingen
 */
export const getSamtykke = () => {
    if (hasPersonverninnstilling(Personverninnstilling.SamtykkeDigitalHelsetjeneste)) {
        return Samtykke.Full;
    }
    if (hasPersonverninnstilling(Personverninnstilling.SamtykkeJournalinnsyn)) {
        return Samtykke.BasisPluss;
    }
    if (hasPersonverninnstilling(Personverninnstilling.SamtykkeRegisterinnsyn)) {
        return Samtykke.Basis;
    }
    return Samtykke.Ingen;
};
/**
 * Sjekk om bruker har samtykket til bruk av Helsenorge
 * @returns true dersom bruker har samtykket
 */
export const hasSamtykke = () => getSamtykke() !== Samtykke.Ingen;
/**
 * Sjekker etter om bruker har fullt samtykke
 * @returns true dersom bruker har fullt samtykke
 */
export const hasFulltSamtykke = () => getSamtykke() == Samtykke.Full;
/**
 * Sjekker etter om bruker har samtykket til bare basis eller basis+
 * @returns true dersom bruker har samtykket til bare basis eller basis+
 */
export const hasBasisOrBasisPlussSamtykke = () => getSamtykke() == Samtykke.Basis || getSamtykke() == Samtykke.BasisPluss;
/**
 * Sjekk om bruker ikke har samtykket til bruk av Helsenorge
 * @returns true dersom bruker ikke har samtykket
 */
export const doesNotHaveSamtykke = () => !hasSamtykke();
/**
 * Sjekk om bruker har aktivt foreldresamtykke.
 * Denne brukes når en foreldre har samtykket på vegne av barnet at de kan bruke helsenorge selv,
 * og da tilgjengeliggjøres et sett med forhåndsdefinerte tjenester.
 * @param personverninnstillinger Valgfri liste med personverninnstillinger. Hvis ikke oppgitt, hentes fra window.HN.User
 * @returns true dersom bruker har foreldresamtykke
 */
export const getHarAktivtForeldreSamtykke = (personverninnstillinger) => {
    return hasPersonverninnstilling(Personverninnstilling.HarAktivtForeldreSamtykke, personverninnstillinger);
};
